import { RemoteErrors } from '../types';

export default function remoteErrorsToFormErrors<T>(
	remoteErrors: RemoteErrors,
	setError: (key: keyof T, err: { message: string }) => void,
) {
	let errors = remoteErrors.response?.data?.errors as
		| {
				[key in keyof T]: string;
		  }
		| undefined;
	if (errors && Object.keys(errors).length) {
		Object.keys(errors).forEach(((key: keyof T) => {
			const value = errors?.[key];
			if (!value) return;
			if (typeof value === 'string') setError(key, { message: value });
			if (Array.isArray(value) && value.length) {
				setError(key, { message: value[0] });
			}
		}) as (value: string) => void);
	}
}
